import { TEAL, CREAM, CREAM30 } from "../utils/constants";

function Logo() {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="8" cy="20" r="3" fill={TEAL} />
        <path d="M8 14c4.5 0 6 1.5 6 6" stroke={TEAL} strokeWidth="2.5" fill="none" strokeLinecap="round" />
        <path d="M8 8c8 0 12 4 12 12" stroke={TEAL} strokeWidth="2.5" fill="none" strokeLinecap="round" />
      </svg>
      <span style={{ fontSize: 20, fontWeight: 700, color: CREAM, letterSpacing: -0.5, fontFamily: "'Space Grotesk', sans-serif" }}>Signal<span style={{ color: TEAL }}>Path</span></span>
      <span style={{ fontSize: 10, color: CREAM30, padding: "2px 6px", border: `1px solid ${CREAM30}`, borderRadius: 4, fontFamily: "'JetBrains Mono', monospace" }}>by AI Signals</span>
    </div>
  );
}

export default Logo;
